import * as React from "react"

function Facebook(props) {
  return (
    <svg viewBox="0 0 550 550" {...props}>
      <circle cx={275} cy={275} fill="#3F65A6" r={256} />
      <path
        d="M236.1 190.8v40.4h-29.6v49.4h29.6V416h60.8V280.5h40.8s3.8-23.7 5.7-49.6h-46.2v-33.8c0-5 6.6-11.8 13.2-11.8h33.1v-51.4h-45c-63.9.1-62.4 49.5-62.4 56.9z"
        fill="#FFF"
      />
    </svg>
  )
}

export default Facebook